import { useState } from "react";
import BlockRenderer from "./BlockRenderer";

const AccordionBlock = ({ block }) => {
  const content = block.content;
  const [expandedItems, setExpandedItems] = useState({});

  const toggleAccordion = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="accordion-block">
      {content.items.map((item, index) => (
        <div key={`accordion-${index}`} className="accordion-item">
          <div 
            className="accordion-header" 
            onClick={() => toggleAccordion(index)}
            aria-expanded={expandedItems[index]}
            aria-controls={`panel${index}-content`}
          >
            <div className="accordion-title">{item.title}</div>
            <div className={`accordion-icon ${expandedItems[index] ? 'accordion-icon-expanded' : ''}`}>
              ▼
            </div>
          </div>
          {expandedItems[index] && (
            <div 
              className="accordion-content"
              id={`panel${index}-content`}
            >
              {item.blocks &&
                item.blocks.map((subBlock, subIndex) => (
                  <BlockRenderer
                    key={`accordion-block-${index}-${subIndex}`}
                    block={subBlock}
                  />
                ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccordionBlock;